import * as React from 'react';
import { forwardRef, Ref, useMemo } from 'react';
import _chunk from 'lodash/chunk';
import { Button as MuiButton, CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
import ReactExport from 'react-export-excel';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const EXCEL_PAGE_CHUNK_SIZE = 20000;

interface Props<T> {
  fileName: string;
  sheetName?: string;
  exportData: T[];
  width?: number;
  exportLoading?: boolean;
  onClickExport: () => void;
  buttonText?: string;
}

const ExcelExportButton = forwardRef(
  <T extends {}>(
    {
      fileName,
      exportData,
      sheetName = 'data',
      width = 100,
      exportLoading = false,
      onClickExport,
      buttonText = 'Export',
    }: Props<T>,
    ref: Ref<HTMLButtonElement>,
  ) => {
    // 시트 페이지당 3-4만을 넘어가면 라이브러리가 뻗는다. 안정적으로 2만 즘에서 슬라이스해서 제공
    const pagingArray = useMemo(() => _chunk(exportData, EXCEL_PAGE_CHUNK_SIZE), [exportData]);

    return (
      <>
        <Button
          width={width}
          variant={'contained'}
          onClick={onClickExport}
          size={'small'}
          disabled={exportData.length === 0 || exportLoading}
        >
          {exportLoading ? <CircularProgress size={22} thickness={5} /> : buttonText}
        </Button>
        {exportData.length > 0 && (
          <ExcelFile filename={fileName} element={<button hidden ref={ref} />}>
            {pagingArray.map((pageData, index) => {
              const pageName = `${sheetName}_${index}`;
              return (
                <ExcelSheet key={pageName} data={pageData} name={pageName}>
                  {Object.keys(pageData[0]).map(key => (
                    <ExcelColumn key={key} label={key} value={key} />
                  ))}
                </ExcelSheet>
              );
            })}
          </ExcelFile>
        )}
      </>
    );
  },
);

export default ExcelExportButton;

const Button = styled(MuiButton)<{ width: number }>`
  width: ${props => props.width}px;
`;
